import React from 'react'
import { Link, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import MuiDialogContent from '@material-ui/core/DialogContent'

const useStyles = makeStyles((theme: Theme) => {
  return {
    styleLink: {
      margin: 0,
      color: theme.palette.primary.main,
    },
    root: {
      margin: 0,
      marginTop: '10.5px',
    },
    label: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14),
    },
    vectorLabel: {
      color: '#595959',
      fontSize: theme.typography.pxToRem(13),
    },
    vectorLabel2: {
      paddingBottom: theme.spacing(4),
    },
    vectorLabel3: {
      paddingLeft: theme.spacing(4),
    },
    clearButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  }
})
export interface DialogTitleProps {
  id: string
  children: React.ReactNode
  onClose: () => void
}
const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const CustomCrisprSolutionsPopUp = () => {
  const classes = useStyles()
  const email = 'crRNA@merckgroup.com'
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleClick = (event): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'modified-popover' : undefined
  const renderData = () => {
    const result: any[] = []
    for (let i = 1; i <= 5; i++) {
      result.push(
        <div className={classes.vectorLabel3}>
          &bull; &nbsp;
          <FormattedMessage
            {...messages[
              `SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_PART_${i}_crisprgrna`
            ]}
          />
        </div>
      )
    }
    return result
  }
  return (
    <>
      <Link
        component="button"
        underline={'hover'}
        onClick={handleClick}
        className={classes.styleLink}
      >
        <i>
          <FormattedMessage {...messages.CUSTOM_CRISPR_SOLUTIONS} />
        </i>
      </Link>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={classes.label}>
          <DialogContent>
            <div className={classes.vectorLabel}>
              <div className={classes.vectorLabel2}>
                <FormattedMessage
                  {...messages.SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_ONE_crisprgrna}
                />
                &nbsp;
                <a href={`mailto:${email}`}>{email}</a>
                &nbsp;
                <FormattedMessage
                  {...messages.SEMICONF_CUSTOM_CRISPR_SOLUTIONS_CONTENT_HEADING_PART_TWO_crisprgrna}
                />
                <div>{renderData()}</div>
              </div>
            </div>
          </DialogContent>
        </div>
      </Popover>
    </>
  )
}
export default CustomCrisprSolutionsPopUp
